export default "__VITE_ASSET__61000f9b__"